export default {"src":"/_next/static/media/stars_3.f93895e7.svg","height":756,"width":756,"blurWidth":0,"blurHeight":0};